import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-[#003A7D] text-white py-4">
      <div className="max-w-8xl mx-auto px-4 md:px-14">
        {/* Navigation Links - Desktop Only */}
        <div className="hidden text-sm lg:flex justify-end space-x-14 mt-8 mb-20 mr-8">
          <a href="/about" className="text-blue-200 hover:text-white">ABOUT</a>
          <a href="/services" className="text-blue-200 hover:text-white">SERVICES</a>
          <a href="/works" className="text-blue-200 hover:text-white">WORK</a>
          <a href="/contact" className="text-blue-200 hover:text-white">CONTACT</a>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-16">
          <img src="/logo/logo2.png" alt="Logo" className="h-28 w-auto" />
          
          {/* Contact Section */}
          <div className="lg:col-span-1">
            <h3 className="font-semibold mb-4 text-lg">CONTACT</h3>
            <div className="space-y-2">
              <p>
                <a href="tel:+251116660544" className="hover:underline">+251-116-660-544</a>
              </p>
              <p>
                <a href="tel:+251911208646" className="hover:underline">+251-911-208-646</a>
              </p>
              <p>
                <a href="mailto:yetwinscon@gmail.com" className="hover:underline">yetwinscon@gmail.com</a>
              </p>
            </div>
          </div>
          
          {/* Office Section */}
          <a
            href="https://www.google.com/maps/search/?api=1&query=9.0198,38.810056"
            target="_blank"
            rel="noopener noreferrer"
            className="lg:col-span-1 block"
          >
            <h3 className="font-semibold mb-4 text-lg">OFFICE</h3>
            <div className="space-y-2">
              <p>Hibir Building, 6th Floor</p>
              <p>Equatorial Guinea Street</p>
              <p>Addis Ababa, Ethiopia</p>
            </div>
          </a>
        </div>
        
        {/* Copyright */}
        <div className="border-t-[0.1px] border-white mt-4 pt-3 text-left text-[0.8rem]">
          © 2025 YETWINS CONSTRUCTION PLC. All Rights Reserved.
        </div>
      </div>
    </footer>
  )
}

export default Footer